import React from "react";
import { getFullName, getAddress } from "../../components/util/helpers";
import { IonLabel, IonItem, IonAvatar } from "@ionic/react";
import { ReactComponent as AvatarImg } from "../../assets/avatar.svg";
import {
  loadRecord,
  loadPlan,
  loadPersonalFile,
} from "../patient/patientSlice";
import { useDispatch } from "react-redux";
import { Img } from "react-image";
import { useHistory } from "react-router-dom";
var flatten = require("flat");

const PatientItem = (props) => {
  const { item } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <IonItem
      key={item.id}
      detail={true}
      onClick={async () => {
        const params = {
          id: item.id,
          branchId: item.branch,
          admin: false,
          patientId: item.id,
        };
        await dispatch(loadRecord(params));
        await dispatch(loadPlan(params));
        await dispatch(loadPersonalFile({ patientId: item.id }));
        history.push(`/app/patients/${item.branch}/${item.id}`);
      }}
    >
      <IonAvatar slot="start">
        {item.avatar_url ? (
          <Img
            src={[item.avatar_url]}
            unloader={<AvatarImg style={{ borderRadius: "50%" }} />}
          />
        ) : (
          <AvatarImg style={{ borderRadius: "50%" }} />
        )}
      </IonAvatar>
      <div style={{ padding: "8px 0" }}>
        <IonLabel>{getFullName(item.surename, item.first_name)}</IonLabel>
        <IonLabel color="medium">
          {getAddress(flatten(item, { safe: true }))}
        </IonLabel>
      </div>
    </IonItem>
  );
};

export default PatientItem;
